import fireAnalytics from '~/services/analytics/fireAnalytics';

export const fireVisitedAmbassadorApply = () =>
  fireAnalytics('Visited Ambassador Apply');

export const fireClickedAmbassadorApply = () =>
  fireAnalytics('Clicked Ambassador Apply');

export const fireVisitedAmbassadorRejected = () =>
  fireAnalytics('Visited Ambassador Rejected');

export const fireVisitedAmbassadorQualify = () =>
  fireAnalytics('Visited Ambassador Qualify');
